import { maskAccountNumber } from '@frontend/string';
import { currency } from '@frontend/design-system';
import { CareCreditPatientData, CareCreditPatientStatus } from '../types/care-credit.types';

export type FormatCareCreditDataForDisplayOptions = {
  decimals?: number;
  showLastX?: number;
};

export const formatCareCreditDataForDisplay = (
  { amount, status, careCreditPersonId, accountNumber }: Partial<CareCreditPatientData> = {},
  { decimals = 0, showLastX = 4 }: FormatCareCreditDataForDisplayOptions = {}
) => {
  const statusMap: Record<CareCreditPatientStatus, string> = {
    approved: 'Active',
    'pre-approved': 'Pending',
    'not-enrolled': 'Not Enrolled',
    declined: 'Declined',
    'unknown-or-error': 'Error',
  };

  if (!amount || !status || !careCreditPersonId) {
    return {
      formattedAmount: '',
      formattedStatus: '',
      formattedCareCreditPersonId: '',
      formattedAccountNumber: '',
    };
  }

  return {
    formattedAmount: currency(amount, { decimals }),
    formattedStatus: statusMap[status],
    formattedAccountNumber: maskAccountNumber(accountNumber, {
      showLast: showLastX,
      minimumMaskLength: 4,
      maxMaskLength: 4,
    }),
    formattedCareCreditPersonId: maskAccountNumber(careCreditPersonId, {
      showLast: showLastX,
      normalizeDigits: false,
      maxMaskLength: 10,
    }),
  };
};
